export const replaceInvalidURLParamLocale = (i18n: {
  resolvedLanguage?: string;
  language?: string;
}) => {
  const url = new URL(window.location.href);
  const langParam = url.searchParams.get("lng");

  const setLng = i18n.language ?? i18n.resolvedLanguage ?? "en";

  if (langParam && langParam !== setLng) {
    // sync url param with resolved i18next language
    url.searchParams.set("lng", setLng);
    window.history.replaceState({}, "", url.toString());
  }
};
